var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCogWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13249",
    "data-name": "Group 13249",
    transform: "translate(-66 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13244",
    "data-name": "Group 13244"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18402",
    "data-name": "Rectangle 18402",
    width: 24,
    height: 24,
    transform: "translate(66 250)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.709,7.64c-2.171,0-3.058-1.469-1.979-3.27a2.126,2.126,0,0,0-.84-2.972L16.816.263a2.053,2.053,0,0,0-2.735.688l-.132.218c-1.079,1.8-2.855,1.8-3.946,0L9.871.951A2.018,2.018,0,0,0,7.16.263L5.085,1.4a2.139,2.139,0,0,0-.84,2.983c1.091,1.79.2,3.259-1.967,3.259A2.238,2.238,0,0,0,0,9.82v2.019a2.238,2.238,0,0,0,2.279,2.18c2.171,0,3.058,1.469,1.967,3.27a2.126,2.126,0,0,0,.84,2.972L7.16,21.4A2.053,2.053,0,0,0,9.9,20.709l.132-.218c1.079-1.8,2.855-1.8,3.946,0l.132.218a2.053,2.053,0,0,0,2.735.688l2.075-1.136a2.128,2.128,0,0,0,.84-2.972c-1.091-1.8-.2-3.27,1.967-3.27A2.238,2.238,0,0,0,24,11.839V9.82A2.256,2.256,0,0,0,21.709,7.64Zm-9.715,6.919A3.824,3.824,0,0,1,8.1,10.83a3.824,3.824,0,0,1,3.9-3.729,3.824,3.824,0,0,1,3.9,3.729A3.824,3.824,0,0,1,11.994,14.559Z",
    transform: "translate(66 251.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogWheel);
export default __webpack_public_path__ + "static/media/CogWheel.616d562a89d56bfc6651c72644e8f04a.svg";
export { ForwardRef as ReactComponent };